import { Card } from "antd";
import React from "react";

const Contacts = () => {
  return <Card>Contacts</Card>;
};

export default Contacts;

